import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../../../auth/services/authentication.service';
import { AppModalComponent } from 'src/app/shared/components/app-modal/app-modal.component';
import { ModalConfig } from 'src/app/shared/models/modal.config';
import { ModalConfigHelper } from 'src/app/shared/helpers/modal-config-helper';

@Component({
  selector: 'app-view-job-interest',
  templateUrl: './view-job-interest.component.html',
  styleUrls: ['./view-job-interest.component.scss']
})
export class ViewJobInterestComponent implements OnInit {

  @ViewChild("chatModal") private chatModalComponent: AppModalComponent;
  
  chatModalConfig: ModalConfig;
  candidateAccountId: Observable<string>;
  jobId: string;
  employerAccountId: string;
  canShowDeclineButton: boolean = true;

  constructor(private authService: AuthenticationService,
    private route: ActivatedRoute) {
    this.candidateAccountId = of(authService.getAuthenticatedResult().accountId);
    this.jobId = this.route.snapshot.paramMap.get("jobId");
    this.employerAccountId = this.route.snapshot.paramMap.get("employerAccountId");
    this.chatModalConfig = ModalConfigHelper.getDiscussModalConfig(this.onDismiss);
  }

  ngOnInit(): void {
  }

  onDiscussClicked() : void {
    this.chatModalComponent.open();
  }

  onDismiss = (): Observable<boolean> => {
    return of<boolean>(true);
  };
}
